import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'transformCurrencyMultiple'
})
export class TransformCurrencyMultiplePiPe implements PipeTransform {
    transform(listValue, listItem, property = 'id') {
        let valueTransform = [];
        listValue.forEach(x => {
            const currencySelected = listItem.find(p => p[property] === x);
            const substrCode = (currencySelected.code.length <= 2 ? currencySelected.code : currencySelected.code.substring(0, 2)).toLowerCase();
            const flag = `flag-icon flag-icon-${substrCode}`;
            valueTransform = valueTransform.concat(`<span class="${flag}"></span>&nbsp;<span>${currencySelected.code}</span>`);
        });
        return valueTransform.join(' | ');
    }
}
